import React from 'react';
import { Button, Box } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { EmissionAllocation } from 'api';
import { CustomMaterialTable } from 'components';

interface AllocationSetupsTableProps {
    data: EmissionAllocation[];
    columns: MRT_ColumnDef<EmissionAllocation>[];
    onViewDetails: (allocationId: number) => void;
}

export const AllocationSetupsTable = ({ data, columns, onViewDetails }: AllocationSetupsTableProps) => (
    <Box sx={{ mt: '20px', width: '100%' }}>
        {data?.length > 0 ? (
            <CustomMaterialTable
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                data={data}
                enablePagination={false}
                columns={columns}
                enableStickyHeader
                initialState={{ density: 'compact' }}
                enableRowActions
                positionActionsColumn="last"
                renderRowActions={({ row }: any) => (
                    <Button
                        variant="text"
                        sx={{ paddingLeft: 0 }}
                        onClick={() => onViewDetails(row.original.allocationId)}
                        aria-label={`View details for allocation ${row.original.allocationId}`}
                    >
                        See Details
                    </Button>
                )}
                containerSx={{
                    width: 'calc(100vw - 150px)',
                    height: 'calc(100vh - 390px)',
                    minHeight: '200px',
                    overflowX: 'auto',
                }}
                muiTableBodyRowProps={({ row }: any) => ({
                    onClick: () => onViewDetails(row.original.allocationId),
                    sx: { cursor: 'pointer', backgroundColor: 'transparent' },
                })}
                getRowId={(row) => String(row.allocationId)}
                muiTableProps={{
                    sx: {
                        tableLayout: 'auto',
                        whiteSpace: 'nowrap',
                    },
                }}
            />
        ) : (
            <Box sx={{ textAlign: 'center', padding: '20px', color: 'text.secondary' }}>
                No allocation setups available.
            </Box>
        )}
    </Box>
);
